.screen {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 26px;
  /* 히어로와 같은 배경. 페이드아웃할 때 검은 깜빡임이 없다. */
  background: var(--film-bg);
  /* 지속 시간은 LoadingScreen.tsx의 LOADING_EXIT_MS가 인라인 스타일로 채워 넣는
     --loading-exit-duration 하나로만 정해진다 — App의 언마운트 타이머와 어긋날 수 없다.
     폴백 0.6s는 그 변수가 없을 때만(예: 스타일 로드 실패) 쓰인다. */
  transition: opacity var(--loading-exit-duration, 0.6s) ease;
}
.exiting {
  /* App이 LOADING_EXIT_MS 뒤에 이 컴포넌트를 언마운트한다 — 트랜지션이 끝까지
     재생될 시간을 준 것이다. pointer-events: none은 그 사이 페이드 중인 화면을
     통해 탈출 버튼이 눌리는 일을 막는다(버튼에도 disabled를 추가로 둔다). */
  opacity: 0;
  pointer-events: none;
}
.title {
  /* 'Alex Brush Boot'는 로딩 화면 한 줄만 담은 인라인 base64 서브셋(bootFont.css)이다.
     히어로와 같은 스크립트 서체를 쓰고 싶지만 그 서체는 아직 다운로드 중이므로,
     첫 프레임부터 바로 그려지는 이 서브셋을 먼저 쓰고 --font-script로 폴백한다. */
  font-family: 'Alex Brush Boot', var(--font-script);
  font-size: 44px;
  line-height: 1.25;
  letter-spacing: 1px;
  color: var(--pink-film);
  text-align: center;
  text-shadow: 0 1px 3px rgba(10, 8, 6, 0.5), 0 4px 16px rgba(10, 8, 6, 0.4);
}
.track {
  width: min(58vw, 220px);
  height: 1px;
  background: rgba(255, 255, 255, 0.22);
  overflow: hidden;
}
.fill {
  height: 100%;
  background: var(--pink-film);
  transition: width 0.25s ease-out;
}
.escape {
  margin-top: 8px;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  background: none;
  padding: 4px 6px 7px;
  font-family: var(--font-label);
  font-size: 12.5px;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  animation: fadeUp 0.5s ease both;
}
